import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';

if (process.env.NODE_ENV === 'development') {
  // @ts-ignore - react-error-overlay has no type declarations
  import('react-error-overlay').then((ErrorOverlay) => {
    ErrorOverlay.stopReportingRuntimeErrors();
  });
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
